import { combineReducers } from 'redux';
import { covisage } from './covisage.reducer';

const rootReducer = combineReducers({
  covisage
});

export default rootReducer;